export default __webpack_public_path__ + "static/media/authbackground.3ad78746.png";